export const CLASSROOM_SECTION_TEMPLATE = {
  LIVE_LESSON: 'live_lesson',
  DISCUSSION_FILES: 'discussion_files',
  ASSIGNMENT: 'assignment',
};

export const CHANNEL_TABS = {
  LIVE: 'live',
  DISCUSSION: 'discussion',
  FILES: 'files',
  ASSIGNMENTS: 'assignments',
  ASSESSMENT: 'assessment',
};

export const CALENDAR_EVENT_TYPES = {
  LIVE_SESSION: 'live_session',
  ASSIGNMENT_DUE: 'assignment_due',
  EXAM: 'exam',
  CUSTOM: 'custom',
};

export const CALENDAR_EVENT_COLORS = {
  live_session: '#0E6C81', // palette.blu800
  assignment_due: '#FF9A03', // palette.ora500
  exam: '#F63D4F', // palette.red500
  custom: '#571A98', // palette.pur900
};

export const WIZARD_STEPS = {
  NAME: 0,
  SUBJECTS: 1,
  TEACHERS: 2,
  STUDENTS: 3,
  REVIEW: 4,
};
